import { render, staticRenderFns } from "./InputCopy.vue?vue&type=template&id=595de2f0&scoped=true&"
import script from "./InputCopy.vue?vue&type=script&lang=js&"
export * from "./InputCopy.vue?vue&type=script&lang=js&"
import style0 from "./InputCopy.vue?vue&type=style&index=0&id=595de2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595de2f0",
  null
  
)

export default component.exports